import React from 'react';

import {Image} from 'primereact/image'

import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'


const Page = () => {

    const imgs = [];
    imgs.push({
        imageSrc: './news/IRD visiting CMU_250618/cover.jpg',
        alt: 'cover',
        title: 'cover',
        thumbnailImageSrc: './news/IRD visiting CMU_250618/cover.jpg'
    })
    for (let i = 1; i<=10; i++){
        imgs.push({
            imageSrc: `./news/IRD visiting CMU_250618/pic${i}.jpg`,
            alt: `pic${i}`,
            title: `pic${i}`,
            thumbnailImageSrc: `./news/IRD visiting CMU_250618/pic${i}.jpg`
        });
    }

    const detail = 
        {
            id:1,
            ini:'The visit of IRD delegation to Chiang Mai University',
            href:'',
            element:'',
            topic:'',
            inform: `On June 18, 2025, Professor Dr. Pongruk Sribanditmongkol, President of Chiang Mai University, together with the university’s executive team, warmly welcomed 
            <ul>
                <li><b>Mr. Gilles Pécassou:</b> Deputy Director General</li>
                <li><b>Mr. Vincent Drapeau:</b> Asia and Pacific Project Manager</li>
                <li><b>Mr. Xavier Mari:</b> IRD Representative in Bangkok</li>
            </ul>
            The purpose of the visit was to pay a courtesy call on the university executives, discuss potential future collaborations and research support, and present academic outcomes from previous joint efforts, particularly those in partnership with the Faculty of Associated Medical Sciences.`,
            link1: 'https://www.cmu.ac.th/th/article/96cadb88-7281-4761-a53a-303002fba654?fbclid=IwY2xjawLBrxJleHRuA2FlbQIxMABicmlkETF0VXBnUnVncTdhWDd4SW9iAR6JpZQMoUXer1Ei6ua0tAzEip5IOGxvIv8E1BhesvUtvDFEZJsBuUJwxtVoUg_aem_VSUt3k0hTSFHk6eDfYtTDg'
        
        }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }


    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((imgs,index)=>(
                        <div className="item" key={index}><img src={imgs.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
               <div className="btn">
                     <h2>MORE INFORMATION</h2>
                     <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
            <div className="gallery">
                {imgs.map((img) =>(
                    <div className="img">
                        <Image src={img.imageSrc} alt='img' width='200' preview></Image>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Page;
